<template>
  <div>
    <sub-content-container :title="$t('aboutMe.education.pageLabel')">
      <school-degree v-for="(degree, i) in completeDegrees" :degree="degree" :key="`degree-${i}`" />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const SchoolDegree = () =>
  import(/* webpackChunkName: "EducationPage" */ "@/components/AboutMe/SchoolDegree.vue");

export default {
  name: "Education",
  components: {
    SubContentContainer,
    SchoolDegree
  },
  data() {
    return {
      degrees: [
        {
          school:
            "Unidad Profesional Interdisciplinaria en Ingeniería y Tecnologías Avanzadas del Instituto Politécnico Nacional",
          href: "https://www.upiita.ipn.mx/",
          logotype: "/img/schoolsLogotype/upiita.png",
          grade: 9.17
        },
        {
          school:
            'Centro de Estudios Científicos y Tecnológicos No. 10 "Carlos Vallejo Márquez" del Instituto Politécnico Nacional',
          href: "https://www.cecyt10.ipn.mx/",
          logotype: "/img/schoolsLogotype/cecyt10.png",
          grade: 9.54
        }
      ]
    };
  },
  computed: {
    completeDegrees() {
      return this.degrees.map((data, i) => ({
        ...data,
        ...this.$t("aboutMe.education.degrees")[i]
      }));
    }
  }
};
</script>
